/**
 * Node Prop 变化事件
 * @Deprecated Please Replace With InnerPropChange
 */
export var Change = 'node.prop.change';

/** Node Prop 变化事件 */
export var InnerChange = 'node.innerProp.change';